<script setup lang="ts">
import ListName from "@/components/lists/list-accessory-name.vue";

defineProps<{
  ownerId: string;
}>();
</script>

<template>
  <section class="tab-console">
    <div class="content">
      <list-name :owner-id="ownerId" />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.tab-console {
  display: flex;
  flex-direction: column;
  padding-block: 1rem;
  gap: 1rem;

  .content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
}

@media screen and (max-width: 1024px) {
  .tab-console {
    .content {
      padding-inline: 0;
    }
  }
}
</style>
